import axios from '../api/index.js';

//查询新闻中心列表
export let getNewsList = (params) => {
    return axios.post(`/perform/news/list`, params);
};

//查询新闻中心详情
export let getNewsContent = (params) => {
    return axios.get(`/perform/news/${params}`);
};

//关键字搜索
export let getNewsSearch = (params) => {
    return axios.post(`/client/news/search`,params);
};



// WEBPACK FOOTER //
// ./src/api/news.js